import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { useResponsiveness } from '../../responsiveness/useResponsiveness';
import { BackLink } from '../BackLink/BackLink';
import { Header } from '../Header/Header';
import { ViewContainer } from '../ViewContainer/ViewContainer';
import { LayoutType } from '../../types';
import { BackButton, ViewContainerWrapper } from './LayoutTemplate.styles';
import { ManageCookies } from '../ManageCookies/ManageCookies';
export const LayoutTemplate = ({
  layoutType = LayoutType.CentredStep,
  showBackLink = false,
  showHaveAnAccountLink = false,
  showLogo = false,
  showProgressIndicator = false,
  totalSteps,
  currentStepNumber,
  waveType,
  accountLinkMessage,
  logoAltText,
  logoImageSrc,
  logoWidth,
  logoHeight,
  backLinkHref,
  accountLinkHref,
  onBackLinkClick,
  onAccountLinkClick,
  onLogoClick,
  children,
  messagingContent,
  alignCentredStepAtTheTop,
  showManageCookiesLink = false,
  shouldLogoBeClickable = true,
  shouldHalveProgressBar = false,
  shouldAddTopPadding = true
}) => {
  const {
    isMobile,
    isDesktop
  } = useResponsiveness();
  const shouldShowBackLink = layoutType !== LayoutType.FramedCentredStep && !isMobile && showBackLink;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(ViewContainerWrapper, {
      children: [/*#__PURE__*/_jsx(Header, {
        totalSteps: totalSteps,
        currentStepNumber: currentStepNumber,
        showMobileView: isMobile,
        showProgressIndicator: showProgressIndicator,
        showLogo: showLogo,
        showHaveAnAccountLink: showHaveAnAccountLink,
        shouldHalveProgressBar: shouldHalveProgressBar,
        accountLinkMessage: accountLinkMessage,
        logoAltText: logoAltText,
        logoImageSrc: logoImageSrc,
        logoWidth: logoWidth,
        logoHeight: logoHeight,
        accountLinkHref: accountLinkHref,
        showBackLink: showBackLink,
        onAccountLinkClick: onAccountLinkClick,
        onLogoClick: onLogoClick,
        onBackLinkClick: onBackLinkClick,
        shouldLogoBeClickable: shouldLogoBeClickable
      }), shouldShowBackLink && /*#__PURE__*/_jsx(BackButton, {
        className: "m-top-4",
        children: /*#__PURE__*/_jsx(BackLink, {
          href: backLinkHref,
          onClick: onBackLinkClick
        })
      }), /*#__PURE__*/_jsx(ViewContainer, {
        alignCentredStepAtTheTop: alignCentredStepAtTheTop,
        shouldAddTopPadding: shouldAddTopPadding,
        showBackLink: showBackLink,
        showMobileView: isMobile,
        layoutType: layoutType,
        waveType: waveType,
        messagingChildren: messagingContent,
        backLinkHref: backLinkHref,
        onBackLinkClick: onBackLinkClick,
        showManageCookiesLink: showManageCookiesLink,
        children: children
      })]
    }), isDesktop && showManageCookiesLink && /*#__PURE__*/_jsx(ManageCookies, {})]
  });
};